import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, ReplaySubject, Observable, timer, takeUntil } from 'rxjs';

export enum SyncEventType {
  INITIAL_UNKNOWN,
  OFFLINE,
  ONLINE,
  SYNCHRONIZING,
  SUCCESS,
  FAIL
}

export enum ApprovedStatus {
  APPROVED = 'approved',
  NOT_APPROVED = 'not_approved',
  UNKNOWN = 'unknown',
}
@Injectable({
  providedIn: 'root'
})
export class StateService {

  isCallOngoing = new BehaviorSubject<boolean>(false);
  dateChanged$ = new ReplaySubject<boolean>();
  public events$ = new ReplaySubject<SyncEventType>(1);
  private patientStatus$ = new ReplaySubject<ApprovedStatus>(1);
  private loggedIn$ = new ReplaySubject<boolean>(1);

  constructor() {
    this.dateChanged$.next(false);
    this.patientStatus$.next(ApprovedStatus.UNKNOWN);
    this.events$.next(SyncEventType.INITIAL_UNKNOWN);
    timer(3000).pipe(
      takeUntil(this.loggedIn$),
    ).subscribe(() => {
      console.log('3 seconds passed, setting default value');
      this.loggedIn$.next(false);
    });
  }

  setLoggedInStatus(loggedIn: boolean) {
    this.loggedIn$.next(loggedIn);
  }

  getLoggedInStatus() {
    return this.loggedIn$.asObservable();
  }

  getPatientStatus(): Observable<ApprovedStatus> {
    return this.patientStatus$.asObservable();
  }

  setPatientStatus(status: ApprovedStatus) {
    this.patientStatus$.next(status);
  }

  setTelehealthCallStatus(status: boolean) {
    this.isCallOngoing.next(status);
  }

  isTelehealthCallOngoing(): boolean {
    return this.isCallOngoing.value;
  }

}
